export default {
  styleOverrides: {
    root: {
      cursor: "pointer",
    },
  },
};
